import './ShareViewButton.scss';

import classNames from 'classnames';
import { coreActions } from '@sonar-software/sonar-core';
import { haltClickEventPropagation } from '@lib/events';
import React from 'react';

import { COPY_SPECIFIC, FULL_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { CopyText, SonarText } from '@ui/text';
import { DeleteOutlined, LinkOutlined } from '@ant-design/icons';
import { Popover, Space } from 'antd';
import { useAction, useBoolean } from '@hooks';

function buildLink(key: string | undefined): string {
	if (!key) {
		return '';
	}

	const link = new URL(window.location.origin);

	link.pathname = FULL_ROUTES.SHARED_VIEW.replace(PARAMS.ID, key);

	return link.toString();
}

export interface ShareViewButtonProps {
	className?: string;
	existingSharedKey?: string;
	viewId: number;
}

export const ShareViewButton: React.FC<ShareViewButtonProps> = ({ className, existingSharedKey, viewId }) => {
	const [ isOpen, setIsOpen ] = useBoolean();

	const requestKey = useAction(coreActions.requestPostCoreDataDictionaryViewsSharedKey);
	const deleteKey = useAction(coreActions.requestDeleteCoreDataDictionaryViewsSharedKey);

	const linkText = buildLink(existingSharedKey);
	const displayText = linkText ? '' : COPY_SPECIFIC.CREATING_EMBEDDABLE_LINK;
	const linkClasses = classNames('view-label-share', { 'view-label-share-active': existingSharedKey }, className);

	return (
		<Popover
			arrow={ false }
			classNames={ { root: 'view-share-link-modal' } }
			content={
				<div onClick={ haltClickEventPropagation }>
					{ existingSharedKey &&
						<SonarText className='share-link-label'>{ COPY_SPECIFIC.VIEW_IS_SHAREABLE }</SonarText> }
					<Space className='share-link-actions'>
						<CopyText
							displayText={ displayText }
							loading={ !existingSharedKey }
							text={ linkText } />
						{ existingSharedKey &&
							<DeleteOutlined
								className='delete-share-link'
								onClick={ (e) => {
									e.stopPropagation();

									deleteKey({ viewId });

									setIsOpen.off();
								} } /> }
					</Space>
				</div>
			}
			getPopupContainer={ () => document.getElementsByClassName('view-selector')[ 0 ] as HTMLElement }
			onOpenChange={ (value) => {
				if (value) {
					if (!existingSharedKey) {
						requestKey({ viewId });
					}

					setIsOpen.on();
				} else {
					setIsOpen.off();
				}
			} }
			open={ isOpen }
			placement='bottom'
			trigger='click'
			zIndex={ 1100 }>
			<LinkOutlined
				className={ linkClasses }
				onClick={ haltClickEventPropagation } />
		</Popover>
	);
};
